import { useContext, useMemo } from 'react';
import { SignInContext } from '@modules/users';
import { getProjectStages, updateStageGate } from '../helpers';
import useProjectStagesStore from '../stores/useProjectStagesStore';
import type { TGateState } from '../types';

/** Empty when `organization.mock.projectStages` has no stages for the project. */
const useProjectStages = (projectId: string) => {
  const { organization } = useContext(SignInContext);
  const projectStages = organization.mock?.projectStages;
  const configuredStages = useMemo(() => getProjectStages(projectStages, projectId), [projectStages, projectId]);
  const storedStages = useProjectStagesStore((state) => state.stagesByProject[projectId]);
  const setStages = useProjectStagesStore((state) => state.setStages);
  const stages = storedStages ?? configuredStages;
  const updateGate = (stageIndex: number, changes: Partial<TGateState>) =>
    setStages(projectId, updateStageGate(stages, stageIndex, changes));
  return { stages, updateGate };
};

export default useProjectStages;
